<template >
    <div>
        <template v-for="menu in menus">
            <el-button  size="mini" plain :type="menu.css==''?'primary':menu.css" @click="handleclick(menu.linkurl, index, row)" :key="menu.id" v-if="ignore_ids.indexOf(','+menu.id+',')<0">
                {{menu.name}}
            </el-button>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        menu_id: {
            type: Number,
            default() {
                return 0
            }
        },
        row: {
            type: Object,
            default() {
                return {}
            }
        },
        index: {
            type: Number,
            default(){
                return 0
            }
        },
        menus: {
            type: Array,
            default(){
                return []
            }
        },
        ignore_ids: {
            type: String,
            default() {
                return ''
            }
        }
    },
    methods: {
        handleclick(func, index, row){
            this.$emit('on_btnclk',{func: func, index: index, row: row});
        },
    }
}
</script>